import React, { useState } from "react";
import { BASEURL } from "../../configuration/configuration";
import PrimaryButton from "./PrimaryButton";

const initial = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  address: "",
  message: "",
};

const ContactForm = () => {
  const [form, setForm] = useState(initial);
  const [status, setStatus] = useState({ type: "", text: "" });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", text: "" });

    const payload = {
      first_name: form.firstName,
      last_name: form.lastName,
      email_id: form.email,
      phone: form.phone,
      address: form.address,
      message: form.message,
    };

    try {
      const response = await fetch(`${BASEURL}/contacts/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("submit failed");

      setStatus({ type: "ok", text: "Submitted successfully!" });
      setForm(initial);
    } catch (err) {
      setStatus({
        type: "err",
        text: "Error submitting form. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="sv-form" onSubmit={onSubmit}>
      <h2 className="sv-h3">Get your health product today!</h2>

      <div className="sv-form__row">
        <div className="sv-field">
          <label htmlFor="firstName">First Name *</label>
          <input
            id="firstName"
            name="firstName"
            required
            value={form.firstName}
            onChange={onChange}
          />
        </div>
        <div className="sv-field">
          <label htmlFor="lastName">Last Name *</label>
          <input
            id="lastName"
            name="lastName"
            required
            value={form.lastName}
            onChange={onChange}
          />
        </div>
      </div>

      <div className="sv-form__row">
        <div className="sv-field">
          <label htmlFor="email">E-mail *</label>
          <input
            id="email"
            name="email"
            type="email"
            required
            value={form.email}
            onChange={onChange}
          />
        </div>
        <div className="sv-field">
          <label htmlFor="phone">Phone Number *</label>
          <input
            id="phone"
            name="phone"
            type="tel"
            required
            value={form.phone}
            onChange={onChange}
          />
        </div>
      </div>

      <div className="sv-field">
        <label htmlFor="address">Address</label>
        <input
          id="address"
          name="address"
          value={form.address}
          onChange={onChange}
        />
      </div>

      <div className="sv-field">
        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          rows={4}
          value={form.message}
          onChange={onChange}
        />
      </div>

      {status.text ? (
        <p
          className={`sv-form__msg ${
            status.type === "ok" ? "sv-form__msg--ok" : "sv-form__msg--err"
          }`}
        >
          {status.text}
        </p>
      ) : null}

      <PrimaryButton type="submit">
        {loading ? "Submitting…" : "Submit"}
      </PrimaryButton>
    </form>
  );
};

export default ContactForm;
